<template>
  <v-card flat class="v-card--no-padding partner-tile">
    <div class="partner-tile__pictures">
      <v-img
        lazy-src="/img/partner-background-no-image.jpg"
        class="partner-tile__bg-image"
        :src="imgSrc ? mediaUrl + imgSrc : '/img/partner-background-no-image.jpg'"
      />

      <div v-if="logoSrc" class="partner-tile__avatar">
        <v-img contain alt="avatar" :src="mediaUrl + logoSrc" />
      </div>
    </div>

    <div class="v-card__padding-content d-flex flex-column justify-space-between">
      <div>
        <div class="v-card-h2 partner-tile__title">{{ title }}</div>

        <div class="v-card-h4 partner-tile__description">{{ subtitle ? subtitle : 'Brak opisu' }}</div>
      </div>
      <slot />
    </div>
  </v-card>
</template>

<script>
import { mediaMixin } from '@/mixins/media';

// @vuese
// Karta
// @group Base
export default {
  mixins: [mediaMixin],

  props: {
    // Wysokość obrazka
    imgHeight: {
      type: Number,
      required: false,
      default: 250
    },
    // Wielkość awatara
    avatarSize: {
      type: Number,
      required: false,
      default: 50
    },
    // Czy akcje są włączone
    actions: {
      type: Boolean,
      default: true
    },
    // Źródło obrazka
    imgSrc: {
      type: [String, Number],
      default: ''
    },
    // Źródło logo
    logoSrc: {
      type: [String, Number],
      default: ''
    },
    // Tytuł
    title: {
      type: String,
      required: true
    },
    // Podtytuł
    subtitle: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.v-card .v-avatar {
  margin-top: -120px;
  border-radius: 0 !important;
  width: 120px !important;
  height: 120px !important;
  margin-bottom: 1rem;
}
.v-card .v-avatar img {
  border-radius: 0 !important;
  width: 120px !important;
  height: 120px !important;
}
.v-card__title {
  padding-bottom: 0;
}
.v-card__text div {
  padding-bottom: 10px;
}
.v-card__actions {
  padding: 16px;
}
.v-list__tile {
  font-weight: 500;
  font-size: 14px;
  padding-bottom: 0 !important;
}
.v-list__tile__action {
  min-width: 30px;
}
.v-list__tile--avatar {
  height: auto;
  padding: 3px 0;
}
</style>
